import { JsonApiPayload, ModelLike } from 'services/interfaces/JsonApiPayload';

export class PolicySettingPayload extends JsonApiPayload {
  id: string
  systemTerms: string
  cancellationPolicy: string
  refundPolicy: string
  petPolicy: string
  terms: string
  notes: string

  static new(model?: ModelLike) {
    return super.fill(new this(), model);
  }

  static getSchema() {
    const result = super._getSchema(this, []);
    return result;
  }
}
